import generateAsyncActions from 'utils/generateAsyncActions';
import alt from 'components/Dispatcher';
import CrmAccountSource from 'sources/crm-opp-ui/CrmAccountSource';

class CrmAccountActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions('fetchAccount', 'searchAccounts'),
      'clearSearch',
      'setSearchTerm'
    );
  }

  fetchAccount(id) {
    return dispatch => {
      dispatch(id);
      CrmAccountSource.fetchAccount(id).then(this.fetchAccountSuccess, this.fetchAccountError);
    };
  }

  searchAccounts(searchTerm) {
    return dispatch => {
      dispatch(searchTerm);
      if (searchTerm && searchTerm.length >= 3) {
        CrmAccountSource.searchAccounts(searchTerm).then(
          this.searchAccountsSuccess,
          this.searchAccountsError
        );
      }
    };
  }
}

export default alt.createActions(CrmAccountActions);
